import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconDocumentFilingStyle0 = cosmosIconCss;

const CosmosIconDocumentFiling$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDocumentFiling extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ec12f5e11361d13294f281d681074f2db6d3b030', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '61eeddfcbefde847a3288faf0d8ad91bfeae35b8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '5679a4311e974a3168881146624b1dafc07a63c6', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.285 10.455 2-2.15a.4.4 0 0 0-.3-.68h-1.25v-2.5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v2.5h-1.25a.4.4 0 0 0-.27.68l2 2.15a.4.4 0 0 0 .57 0Zm-3.637 2.49a.5.5 0 0 0 .384.18h5.936a.5.5 0 0 0 .384-.18l2.35-2.82H18.5v5.75h-15v-5.75h1.797l2.35 2.82ZM6.15 8.805l2.35 2.82h5l2.35-2.82a.5.5 0 0 1 .384-.18H19.5a.5.5 0 0 1 .5.5v7.75a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-7.75a.5.5 0 0 1 .5-.5h3.266a.5.5 0 0 1 .384.18Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconDocumentFilingStyle0; }
}, [1, "cosmos-icon-document-filing", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-document-filing"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-document-filing":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDocumentFiling$1);
            }
            break;
    } });
}

const CosmosIconDocumentFiling = CosmosIconDocumentFiling$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDocumentFiling, defineCustomElement };
